import React, { Component } from 'react';
import './styles/css/app.css';
import Nav from './Nav'
import BlogCards from './components/BlogCards';
import BlogPage from './components/BlogPage';
import axios from "axios";
import { Route, Switch, Link } from "react-router-dom";
import { withRouter } from "react-router";
import {api} from './variables'


class App extends Component {
  constructor(props){
    super(props);
    this.state ={ 
      isLoadingComplete: false,
      blogPosts: [],
    }
  }

  async componentDidMount() {
    await this.getBlogPosts()
  }

  getBlogPosts = async () => {
    try {
      const response = await axios.get(`https://2qsvg3b09c.execute-api.us-east-1.amazonaws.com/prod/blogs?brand=${api.query}`, {
        crossdomain: true,
        headers: {
          "Access-Control-Allow-Origin": "*",
        }
      })
      if (response.status === 200 && response.data) {
        console.log(response.data, "comming back")
        this.setState({
          blogPosts: response.data,
          isLoadingComplete: true,
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  render() {
    return (
      <div>
        <Nav/>
        <div>
        <Switch>
          <Route
                  exact
                  path="/blog"
                  render={props => (
                    <BlogCards {...props} apiData={this.state.blogPosts}/> 
                )}
              />

                <Route
                  exact
                  path="/blog/tag/:tag"
                  render={props => (
                    <BlogCards {...props} apiData={this.state.blogPosts}/> 
                  )}
                /> 

                 <Route
                  exact
                  path="/blog/:id"
                  render={props => (
                    <BlogPage
                      {...props}
                      apiData={this.state.blogPosts}
                      isLoadingComplete={this.state.isLoadingComplete}
                    />
                  )}
                /> 

                {/* <Route component={NotFoundPage} /> */} 
      </Switch>
    </div>
  </div>



    );
  }
}

export default withRouter(App);
